import React from "react";
import ListItem from "./ListItem";
import { gettext } from "../../adapter";
import ListHead from "./ListHead";

const List = ({ sensors }) => {
  window.localStorage.removeItem("sensorsDDCache");
  window.localStorage.setItem("sensorsDDCache", JSON.stringify(sensors));
  let items;
  if (sensors && sensors.length > 0) {
    items = sensors.map(function (item) {
      return <ListItem sensor={item} key={item.id} />;
    });
  } else {
    items = (
      <tr>
        <td colSpan="4">
          <span className="no-results">
            {gettext("Your search did not match any sensors. Please extend your search filter.")}
          </span>
        </td>
      </tr>
    );
  }

  return (
    <div className="table-wrapper">
      <table className="table--moisture">
        <ListHead />
        <tbody>{items}</tbody>
      </table>
    </div>
  );
};

export default List;
